import React from "react";
import { IConfigurationProps } from "../add-tenancy-condition/AddTenancyCondition";
import { Dispatch } from "redux";
import { PropertyDetails } from "../../core/api/models/project";

interface CreateProposalHeaderProps {
    canCompareVersion: boolean;
    dispatch: Dispatch<any>;
    setCanCompareVersion: React.Dispatch<React.SetStateAction<boolean>>;
    setShortListPropertyData: (data: PropertyDetails[]) => void
    title?: string;
    onClose?: () => void
}

export function CreateProposalHeader({ canCompareVersion,
    dispatch,
    setCanCompareVersion,
    setShortListPropertyData,
    title,
    onClose
 }: CreateProposalHeaderProps) {
    return (
        <div className="container-fluid border-bottom py-3 proposal-head">
            <div className="row align-items-center">
                <>
                    <div
                        className="col-auto"
                        onClick={() => {
                            onClose?.();
                            dispatch(setShortListPropertyData([]));
                            setCanCompareVersion(!canCompareVersion);
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                        >
                            <path
                                d="M25.0416 0.292893C24.6511 -0.0976308 24.0179 -0.0976312 23.6274 0.292893L12.6673 11.253L1.70711 0.292893C1.31658 -0.0976312 0.683417 -0.0976308 0.292893 0.292893C-0.0976308 0.683417 -0.0976312 1.31658 0.292893 1.70711L11.253 12.6673L0.292893 23.6274C-0.0976308 24.0179 -0.0976308 24.6511 0.292893 25.0416C0.683417 25.4322 1.31658 25.4322 1.70711 25.0416L12.6673 14.0815L23.6274 25.0416C24.0179 25.4322 24.6511 25.4322 25.0416 25.0416C25.4322 24.6511 25.4322 24.0179 25.0416 23.6274L14.0815 12.6673L25.0416 1.70711C25.4322 1.31658 25.4322 0.683417 25.0416 0.292893Z"
                                fill="#6F7171"
                            />
                        </svg>
                    </div>

                    <label className="font-weight-semibold mb-0 font-lg">
                        {title || "Create Proposal"}
                    </label>
                </>
            </div>
        </div>
    );
}